import {inject, Injectable} from '@angular/core';
import {AuthUserService} from "@common-module/app-services/auth-user.service";
import {Auth} from "@common-module/modelinterfaces/auth.model";
import {User} from "@common-module/modelinterfaces/user.model";
import {RealAuthUserLocalStorageService} from "./local-storage-services/impl/real-auth-user-local-storage.service";
import {ActAsUserLocalStorageService} from "./local-storage-services/impl/act-as-user.local-storage-service";
import {Tab} from "@common-module/app-enums/tab";

@Injectable({
  providedIn: 'root'
})
export class UserPortalAuthUserService extends AuthUserService{

  private readonly realAuthUserLocalStorage: RealAuthUserLocalStorageService = inject(RealAuthUserLocalStorageService);
  private readonly actAsUserLocalStorage: ActAsUserLocalStorageService = inject(ActAsUserLocalStorageService);

  constructor() {
    super();
  }

  public override update(): void {
    this.authRestService.get().subscribe(auth => {
      this.updateAuth(auth)
    });
  }

  // так сделано потому что если пользователь каким то образом выберет пользователя которым не владеет то будут ошибки
  // а так сначала проверяется что пользователь действительно владеет и только потом сохраняет
  public override updateActAs(userId: number) {

    this.authRestService.getActAs(userId)
      .subscribe(auth => {
        this.actAsUserLocalStorage.save(userId);
        this.updateAuth(auth)
      })
  }

  private updateAuth(auth: Auth) {
    this.change(auth.actAs);
    this.changeRealAuth(auth.authUser)
  }

  public changeRealAuth(user: User): void {
    let prevRealAuthUserId = this.realAuthUserLocalStorage.get();
    if (user && prevRealAuthUserId != user?.id) {
      console.log('Real auth user id changed')
    }
    this.realAuthUserLocalStorage.save(user?.id);
    this.changeRealAuthUser(user);
  }



  public logout(commands?: Tab[]): void {
    this.changeRealAuth(null);
    this.realAuthUserLocalStorage.clear();
    this.actAsUserLocalStorage.clear();
    super.logout(commands);
  }

}
